import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    id: Number
  }

  select(event) {
    const salonId = this.idValue
    const selectElement = document.querySelector('#salon_selected_id')
    if (selectElement) {
      selectElement.value = salonId
      selectElement.dispatchEvent(new Event('change'))
    }

    const modal = document.querySelector('#common_modal')
    if (modal) {
      modal.classList.add("hidden")
    }
  }
}